import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from "recharts";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Footer from './Footer';
import Balance from './Balance';
import Nav from './Nav';
import { useEffect, useState } from "react"
import axios from "axios";
import { useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';







const error = (text) => {
  toast.error(text, {
    position: toast.POSITION.TOP_RIGHT
});
};

const success = (text) => {
  toast.success(text, {
    position: toast.POSITION.TOP_RIGHT
});
};





export default function Analysis (props){
    const params = useParams () ;
    const [baseline, setBaseline] = useState([])
    const [dataset, setDataSet] = useState([])
    const [utilities, setUtilities] = useState([])
    const [base5utility, setBase5Utility] = useState([])
    const [base_utility, setBaseUtility] = useState([])
    const [lux, setLux] = useState([])
    const [base_tot, setBaseTot] = useState([])
    const [data2, setData2] = useState([])
    const [project_items, setProjectItems] = useState([])
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
    
    const [additem, setAddItem] = useState([])
    const [addgrade, setAddGrade] = useState([])
    const [addgradea, setAddGradeA] = useState(0)
    const [addgradeb, setAddGradeB] = useState(0)
    const [addgradec, setAddGradeC] = useState(0)
    
    const [addwatt, setAddWatt] = useState([])
    const [addewatt, setAddEWatt] = useState([])
    const [solar_solution, setSolarSolution] = useState([])
    const [panel_load, setPanelLoad] = useState()

    
   

    const [h0, setH0] = useState(0)
    const [h1, setH1] = useState(0)
    const [h2, setH2] = useState(0)
    const [h3, setH3] = useState(0)
    const [h4, setH4] = useState(0)
    const [h5, setH5] = useState(0)
    const [h6, setH6] = useState(0)
    const [h7, setH7] = useState(0)
    const [h8, setH8] = useState(0)
    const [h9, setH9] = useState(0)
    const [h10, setH10] = useState(0)
    const [h11, setH11] = useState(0)
    const [h12, setH12] = useState(0)
    const [h13, setH13] = useState(0)
    const [h14, setH14] = useState(0)
    const [h15, setH15] = useState(0)
    const [h16, setH16] = useState(0)
    const [h17, setH17] = useState(0)
    const [h18, setH18] = useState(0)
    const [h19, setH19] = useState(0)
    const [h20, setH20] = useState(0)
    const [h21, setH21] = useState(0)
    const [h22, setH22] = useState(0)
    const [h23, setH23] = useState(0)

    const [average, setAverage] = useState([])
    const [load, setLoad] = useState([])
    const [battery, setBattery] = useState([])
    const [load_solution, setLoadSolution] = useState([])

    const grade_options = [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
      ];


    const [modalOpen, setModalOpen] = useState(false);
    const [parameter, setParameter] = useState();

    const handleButtonClick = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleSelectItem = (e) =>{
       
        //update select 
        //fetch something from db 
        //update
        setAddItem(e.value)
        get_item_details(e.value)
       
    }

    const get_item_details = async (x) => {
        const result =  await axios("https://api.tydacomm.com/api/user/item?id="+x);
        setAddEWatt(result.data.data.watt)
        setAddWatt(result.data.data.watt)
        //console.log(result.data.data.watt)
    }
    
    

    const analysis = async () => {
        const result = await axios("https://api.tydacomm.com/api/user/get-analysis?project_id="+params.id);
    
        setDataSet(result.data.data[0].dataset);
        setBaseline(result.data.data[0].baseline);
        setUtilities(result.data.data[0].utilities);
        setBase5Utility(result.data.data[0].base5utility);
        setBaseUtility(result.data.data[0].base_utility);
        setLux(result.data.data[0].lux);
        setBaseTot(result.data.data[0].base_tot);
        setData2(result.data.data[0].data2[0]);
        setAverage(result.data.data[0].average[0]);
        setLoad(result.data.data[0].load[0]);
        setBattery(result.data.data[0].battery[0]);
        setLoadSolution(result.data.data[0].load_solution[0]);
        setSolarSolution(result.data.data[0].solar);
        
      };


      const handleModalClose = () => {
       // console.log('Modal closed in App.js');
        // Call your desired function here
        analysis()
      };


      const toogleNavBar = () => {
        console.log('I got to toogle nav bar');
        // Call your desired function here
    
      };
    

  

    
      const project_items_call = async () => {
        var select_data = [];
        const result = await axios("https://api.tydacomm.com/api/user/items");
        

        for(var i =0; i < result.data.data.length; i++){
            var label = result.data.data[i].item+" ("+result.data.data[i].watt+"W)"
            var value = ""+result.data.data[i].id+""
            const temp = {
                value:value, 
                label:label,
            };
            select_data.push(temp)
        }
     



        setProjectItems(select_data);
      
        
      };



      
        //build dataset for items
        var table_data = [];
        var k = 1;
      for(var j = 0; j < dataset.length; j++){
        
            const temp = {
                id:k, 
                row_id: dataset[j][0]['id'],
                item_name:dataset[j][0]['item_name'],
                grade:dataset[j][0]['grade'],
                grade_a:dataset[j][0]['grade_a'],
                grade_b:dataset[j][0]['grade_b'],
                grade_c:dataset[j][0]['grade_c'],
                total_units:dataset[j][0]['total_units'],
                watt:dataset[j][0]['watt'],
                effective_watt:dataset[j][0]['effective_watt'],
                total_watt_a:dataset[j][0]['total_watt_a'],
                total_watt_b:dataset[j][0]['total_watt_b'],
                total_watt_c:dataset[j][0]['total_watt_c'],
                total_watt:dataset[j][0]['total_watt'],
                h0: dataset[j][0]['h0'],
                h1: dataset[j][0]['h1'],
                h2: dataset[j][0]['h2'],
                h3: dataset[j][0]['h3'],
                h4: dataset[j][0]['h4'],
                h5: dataset[j][0]['h5'],
                h6: dataset[j][0]['h6'],
                h7: dataset[j][0]['h7'],
                h8: dataset[j][0]['h8'],
                h9: dataset[j][0]['h9'],
                h10: dataset[j][0]['h10'],
                h11: dataset[j][0]['h11'],
                h12: dataset[j][0]['h12'],
                h13: dataset[j][0]['h13'],
                h14: dataset[j][0]['h14'],
                h15: dataset[j][0]['h15'],
                h16: dataset[j][0]['h16'],
                h17: dataset[j][0]['h17'],
                h18: dataset[j][0]['h18'],
                h19: dataset[j][0]['h19'],
                h20: dataset[j][0]['h20'],
                h21: dataset[j][0]['h21'],
                h22: dataset[j][0]['h22'],
                h23: dataset[j][0]['h23'],
                h0_id: "tx0"+k,
                h1_id: "tx1"+k,
                h2_id: "tx2"+k,
                h3_id: "tx3"+k,
                h4_id: "tx4"+k,
                h5_id: "tx5"+k,
                h6_id: "tx6"+k,
                h7_id: "tx7"+k,
                h8_id: "tx8"+k,
                h9_id: "tx9"+k,
                h10_id: "tx10"+k,
                h11_id: "tx11"+k,
                h12_id: "tx12"+k,
                h13_id: "tx13"+k,
                h14_id: "tx14"+k,
                h15_id: "tx15"+k,
                h16_id: "tx16"+k,
                h17_id: "tx17"+k,
                h18_id: "tx18"+k,
                h19_id: "tx19"+k,
                h20_id: "tx20"+k,
                h21_id: "tx21"+k,
                h22_id: "tx22"+k,
                h23_id: "tx23"+k,

                total_hours:dataset[j][0]['total_hours']
            };

         
           
            
            table_data.push(temp)
            k++;
        }



        //data for graph 

      var datay = [];
      for(var i =0; i < 24; i++){
          const temp = {
              Hour:i, 
              Total_Watts_A:baseline[i],
              Total_Watts_B:utilities[i], 
              Total_Watts_A_B:base_utility[i]
          };
          datay.push(temp)
      }
    

    function handleItemSubmit() {
      
        axios
        .post("https://api.tydacomm.com/api/user/create-analysis", {
            project_id:params.id,
            item_id:additem,
            grade:addgrade,
            grade_a:addgradea,
            grade_b:addgradeb,
            grade_c:addgradec,
            watt:addwatt,
            effective_watt:addewatt,
            h0:h0,
            h1:h1,
            h2:h2,
            h3:h3,
            h4:h4,
            h5:h5,
            h6:h6,
            h7:h7,
            h8:h8,
            h9:h9,
            h10:h10,
            h11:h11,
            h12:h12,
            h13:h13,
            h14:h14,
            h15:h15,
            h16:h16,
            h17:h17,
            h18:h18,
            h19:h19,
            h20:h20,
            h21:h21,
            h22:h22,
            h23:h23
           
        })
        .then((response) => {
            
            analysis()
        }); 
            setShow(false);
          


      
      }

    

     



   
   
   
    useEffect(() => {
        analysis()
        project_items_call()
       
       
      
        
        
      }, []);

//for graph
   



const [isSidebarOpen, setIsSidebarOpen] = useState(true);

const toggleSidebar = () => {
  setIsSidebarOpen(!isSidebarOpen);
};
   
    
    
     



   
    


return (
  <div id="wrapper">
      <Header isSidebarOpen={isSidebarOpen} />
      <ToastContainer />
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          
        <Nav  toggleSidebar={toggleSidebar}/>

    
    <div class="container-fluid">

    
    

    <h1 class="h3 mb-4 text-gray-800">Project (Project Name)</h1>

   


    <Modal show={show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Add Item to Project</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        
    <div class="form-group">
    <Form.Label>Item</Form.Label>
    <Select options={project_items} onChange={handleSelectItem} />
    </div>
    

    <div class="form-group">
        
    <Form.Label><br/>Item Grade</Form.Label>
    <Select options={grade_options} onChange={e =>setAddGrade(e.value)} />
    
    </div>
    

    
      <div class="form-group">
      <Form.Label><br/>Num of Units Grade A</Form.Label>
        <input type="number" class="form-control form-control-user" id="addgradea"
            onChange={e => setAddGradeA(e.target.value)} value={addgradea} />
      </div>
    
      
      <div class="form-group">
      <Form.Label><br/>Num of Units Grade B</Form.Label>
        <input type="number" class="form-control form-control-user" id="addgradeb"
            onChange={e => setAddGradeB(e.target.value)} value={addgradeb} />
      </div>
      <br/>
      
      <div class="form-group">
      <Form.Label>Num of Units Grade C</Form.Label>
        <input type="number" class="form-control form-control-user" id="addgradec"
            onChange={e => setAddGradeC(e.target.value)} value={addgradec}/>
      </div>
      <br/>
      
      <div class="form-group">
      <Form.Label>Watt Rating</Form.Label>
        <input type="number" class="form-control form-control-user" id="addwatt" value={addwatt}
            onChange={e => setAddWatt(e.target.value)}  />
      </div>
      <br/>
      
      <div class="form-group">
      <Form.Label>Effective Watt Rating</Form.Label>
        <input type="number" class="form-control form-control-user" id="addewatt" value={addewatt}
            onChange={e => setAddEWatt(e.target.value)} />
      </div>
      <br/>
      

      <button type='submit' class="btn btn-primary btn-user btn-block" id='login-btn' name='login' onClick={handleItemSubmit}>
                                            Save
            <span class="spn text-light" role="status">
            <span class="sr-only">Loading...</span>
            </span>
        </button>



      

    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>
        Close
      </Button>
      
    </Modal.Footer>
  </Modal>




<br/>
    <div class="row">
    

    


        <div class='col-md-12'>
        <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Building Component analysis</h6>
                                </div>
                                <div class="card-body">
                               
   
        

  
                                <div class='table table-responsive'>
        <table class="table table-striped table-bordered table-sm">
          <thead>
            <tr>
              <th style={{textAlign:"center", position:"sticky",  Zindex:"2", backgroundColor:"#FFFFFF"}}>S/N</th>
              <th style={{textAlign:"center", position:"sticky",  Zindex:"4", backgroundColor:"#FFFFFF"}}>Item</th>
              <th style={{textAlign:"center", position:"sticky",  Zindex:"6", backgroundColor:"#FFFFFF"}}>Grade</th>
              <th style={{textAlign:"center"}}>A<br/>Essential</th>
              <th style={{textAlign:"center"}}>B<br/>Functional</th>
              <th style={{textAlign:"center"}}>C<br/>Luxury</th>
              <th style={{textAlign:"center"}}>Specification<br/>(Watt)</th>
              <th style={{textAlign:"center"}}>Effective<br/>(Watt)</th>
              <th style={{textAlign:"center"}}>Total<br/>Watt</th>
              <th style={{textAlign:"center"}}>Total Hours</th>
              <th style={{textAlign:"center"}}>Balance<br/>Power</th>

              
              


            </tr>
          </thead>
          <tbody>
          {table_data.map(item_row => (
              <tr>
                <td style={{textAlign:"center"}}>{item_row.id}</td>
                <td style={{textAlign:"center"}}>{item_row.item_name}</td>
                <td style={{textAlign:"center"}}>{item_row.grade}</td>
                <td style={{textAlign:"center"}}>{item_row.grade_a}</td>
                <td style={{textAlign:"center"}}>{item_row.grade_b}</td>
                <td style={{textAlign:"center"}}>{item_row.grade_c}</td>
               
                <td style={{textAlign:"center"}}>{item_row.watt.toLocaleString()}</td>
                <td style={{textAlign:"center"}}>{item_row.effective_watt.toLocaleString()}</td>
                
                <td style={{textAlign:"center"}}>{item_row.total_watt.toLocaleString()}</td>
                
                <td style={{textAlign:"center"}}>{item_row.total_hours}</td> 
                <td style={{textAlign:"center"}}>
                  

                    <button class="btn btn-link" onClick={handleButtonClick}>Balance Power</button>
                    <Balance isOpen={modalOpen} onClose={handleCloseModal} item_row={item_row}  onModalClose={handleModalClose} />
                    
                    </td>
                           
                

                </tr>
                
             
            ))}
            <tr>
                
                <td colspan='11' style={{textAlign:"left"}} onClick={handleShow}><FontAwesomeIcon icon={faPlus}  size="lg" /> Add New Item</td>
                
            </tr>
            
           

            
         
   
          
         
          
          </tbody>
        </table>
        </div>
                                </div>
                            </div>

        </div>
    </div>

    <div class="row">
        <div class='col-md-12'>
        <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Power Usage Analysis</h6>
                                </div>
                                <div class="card-body">
                                <div class='table table-responsive'>
        <table class="table table-striped table-bordered table-sm">
          <thead>
            <tr>
              <th>Hour</th>
              <th>0</th>
              <th>1</th>
              <th>2</th>
              <th>3</th>
              <th>4</th>
              <th>5</th>
              <th>6</th>
              <th>7</th>
              <th>8</th>
              <th>9</th>
              <th>10</th>
              <th>11</th>
              <th>12</th>
              <th>13</th>
              <th>14</th>
              <th>15</th>
              <th>16</th>
              <th>17</th>
              <th>18</th>
              <th>19</th>
              <th>20</th>
              <th>21</th>
              <th>22</th>
              <th>23</th>
              <th>Max/Ave</th>
            </tr>
          </thead>
          <tbody>
          <tr>
                <td>Watts(A)</td>
          {baseline.map(x => (
                <td>{x.toLocaleString()}</td>
             
            ))}
            <td>{data2.max_baseline}</td>
            
        </tr>
          
        <tr>
                <td>Watts (B)</td>
          {utilities.map(x => (
                <td>{x.toLocaleString()}</td>
                
             
            ))}
            <td>{data2.max_utilities}</td>
            
        </tr>

        

        <tr>
                <td>Watts (A+B)</td>
          {base_utility.map(x => (
                <td>{x.toLocaleString()}</td>
             
            ))}
            <td>{data2.max_base_utility}</td>
            
        </tr>

        <tr>
                <td>Watts (C)</td>
          {lux.map(x => (
                <td>{x.toLocaleString()}</td>
             
            ))}
            <td>{data2.max_luxury}</td>
            
        </tr>

        <tr>
                <td>Total Watts</td>
          {base_tot.map(x => (
                <td>{x.toLocaleString()}</td>
             
            ))}
            <td>{data2.max_base_total}</td>
        </tr>
         
          
          </tbody>
        </table>
        </div>
                                </div>
                            </div>

        </div>
    </div>
   
        
    <div class="row">
        <div class='col-md-12'>
        <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Power Usage Graph</h6>
                                </div>
                                <div class="card-body" style={{overflowX:"scroll"}}>


        

        <LineChart
          width={1100}
          height={400}
          data={datay}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="4 4" />
          <XAxis dataKey="Hour" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="Total_Watts_A" stroke="#FF0000" activeDot={{ r: 8 }} />
          <Line type="monotone" dataKey="Total_Watts_B" stroke="#0000FF" />
          <Line type="monotone" dataKey="Total_Watts_A_B" stroke="#00FF00" />
        </LineChart>
                                
                                </div>
                            </div>

        </div>
    </div>
       
     
    <div class="row">
        <div class='col-md-6'>
        <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Average</h6>
                                </div>
                                <div class="card-body">
                                    <table class="table table-bordered table-sm">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    Total Watts (A)
                                                </td>
                                                <td>{average.total_watt_a}</td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    Total Watts (B)
                                                </td>
                                                <td>{average.total_watt_b}</td>
                                            </tr>
                                            
                                            <tr>
                                                <td>
                                                    Total of A + B
                                                </td>
                                                <td>{average.base_utility}</td>
                                            </tr>
                                        </tbody>

                                    </table>


        

       
                                
                                </div>
                            </div>

        </div>
        <div class='col-md-6'>
        <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Solution Set</h6>
                                </div>
                                <div class="card-body">
                                    
                                    <table class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th>Solution</th>
                                                <th>A+B</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                           
                                            <tr>
                                                <td>Solar Panel Rating(Watts)</td>
                                                <td>{load_solution.solar_panel_ratting}</td>
                                            </tr>
                                            <tr>
                                                <td>Inverter Rating(KVA)</td>
                                                <td>{load_solution.inverter_rating}</td>
                                            </tr>
                                            <tr>
                                                <td>Battery Rating(WH)</td>
                                                <td>{load_solution.battery_rating}</td>
                                            </tr>
                                            <tr>
                                                <td>Actual House Load</td>
                                                <td>{load_solution.actual_house_load}</td>
                                            </tr>
                                            <tr>
                                                <td>Battery Charging Load</td>
                                                <td>{load_solution.battery_charging_load}</td>
                                            </tr>
                                            <tr>
                                                <td>Total Panel Load</td>
                                                <td>{load_solution.total_panel_load}</td>
                                            </tr>
                                            <tr>
                                                <td>Inverter</td>
                                                <td>{load_solution.inverter}</td>
                                            </tr>
                                        </tbody>

                                    </table>


        

       
                                
                                </div>
                            </div>

        </div>
    </div>
    
    

    <div class="row">
        <div class='col-md-12'>
        <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Solar Panel Recommendation({parseInt(load_solution.solar_panel_ratting)}KW)</h6>
                                </div>
                                <div class="card-body">
                                
                                <div class='table table-responsive'>
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>S/N</th>
                                                <th>Description</th>
                                                <th>Watts</th>
                                                <th>Cost</th>
                                                <th>Length<br/>(mm)</th>
                                                <th>Breadth<br/>(mm)</th>
                                                <th>Area<br/>(m<sup>2</sup>)</th>
                                                <th>Panel <br/>Area</th>
                                                <th>Panels</th>
                                                <th>Actual <br/>Power</th>
                                                <th colspan="3">Solar Array</th>
                                                <th>Final Dimension</th>
                                                <th>Naira<br/>(₦)</th>
                                                <th>Dollar<br/>($) (Rate: 840)</th>
                                                <th>Value<br/>($/Watt)</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        {solar_solution.map(solution => (
                                        <tr>
                                            <td>{solution.id}</td>
                                            <td>{solution.name}</td>
                                            <td>{solution.watt}</td>
                                            <td>{solution.cost}</td>
                                            <td>{solution.length}</td>
                                            <td>{solution.breadth}</td>
                                            <td>{solution.area}</td>
                                            <td>{solution.panel_area}</td>
                                            <td>{solution.number_of_panels}</td>
                                            <td>{solution.actual_power}</td>
                                            <td>{solution.solar_array_1}</td>
                                            <td>{solution.solar_array_2}</td>
                                            <td>{solution.solar_array_3}</td>
                                            <td>{solution.dimension}</td>
                                            <td>{solution.naira}</td>
                                            <td>{solution.dollar}</td>
                                            <td>{solution.value}</td>
                                            

                                            </tr>
                
             
            ))}
                                        
                                            
                                          
                                        </tbody>

                                    </table>
                                </div>

        

       
                                
                                </div>
        </div>

        </div>
       
    </div>
    
  


    

      
        


        


    </div>
   

</div>



<Footer />

</div>
    </div>
  
        
      )
}





 